import { useEffect } from "react";
import M from "materialize-css";

export const useMaterialInputFields = (...args) => {
  useEffect(() => {
    M.updateTextFields();
  }, [...args]);
};
